export const FEED_SCHEMA = {
  en: {
    modals: {
      leaving: {
        title: "Leaving Plaintr",
        warning:
          "This link will take you to {domain}. The article you are about to read is published and maintaned by its original source.",
        primary_cta: "Open Article",
        secondary_cta: "Cancel",
      },
    },
  },
};
